import { DEFAULT_ATTRIBUTES, UID } from 'shared/api/query/constants';
import { aiChat as aiChatConfig, aiChatMessage as aiChatMessageConfig, storageObject as storageObjectConfig } from 'shared/api/query/configs.json';
import { storageObjectEdges } from '@/api/query/nebula/storage-object';

export const children = [
  ...DEFAULT_ATTRIBUTES,
  {
    attr: aiChatMessageConfig.edges.chat,
    model: aiChatConfig.model,
    children: [{ attr: UID }],
  },
  { attr: aiChatMessageConfig.edges.role },
  { attr: aiChatMessageConfig.edges.content, default: '' },
  { attr: aiChatMessageConfig.edges.outcome, default: null },
  {
    attr: aiChatMessageConfig.edges.attachments,
    model: storageObjectConfig.model,
    children: storageObjectEdges,
    default: [],
  },
];
